import * as React from "react";
import { RenderElementProps } from "slate-react";
import { LinkElement as LinkElementType } from "../slate";

const LinkElement = ({
  element,
  attributes,
  children,
}: RenderElementProps & { element: LinkElementType }) => {
  const { href, openNewWindow, title } = element;
  return (
    <a
      title={title || ""}
      href={href}
      target={openNewWindow ? "_blank" : "_self"}
      rel="noreferrer"
      {...attributes}
    >
      {children}
    </a>
  );
};

export default LinkElement;
